import Card         from 'antd/lib/card';
import { Page }     from 'components/Page';
import { Link }     from 'react-router-dom';
import React        from 'react';
import ConfigProxy  from 'tools/ConfigProxy';
import LoginForm    from '../../forms/LoginForm';
import PublicLayout from '../../projectComponents/PublicLayout';

const LoginPage = () => {
	let title = '';
	switch (ConfigProxy.get('PARTITION_URN')) {
		case '$:partition:partition:1':
			title = 'Qualité - Hygiène - Services';
			break;
		case '$:partition:partition:2':
			title = 'DICOP';
			break;
		case '$:partition:partition:3':
			title = 'HPR';
			break;
		case '$:partition:partition:4':
			title = 'HPR Aquitaine';
			break;
		case '$:partition:partition:5':
			title = 'CG2D';
			break;
		case '$:partition:partition:6':
			title = 'RControlClim';
			break;
		case '$:partition:partition:7':
			title = 'IGIENAIR';
			break;
		case '$:partition:partition:8':
			title = 'ADI AMS';
			break;
		case '$:partition:partition:9':
			title = 'AIR SN';
			break;
		case '$:partition:partition:13':
			title = 'NANOSENSE';
			break;
		case '$:partition:partition:14':
			title = 'ADDD';
			break;
		case '$:partition:partition:15':
			title = 'AGETEP';
			break;
		case '$:partition:partition:16':
			title = 'Igienair Grandes cuisines';
			break;
		case '$:partition:partition:17':
			title = 'Igienair International';
			break;
		case '$:partition:partition:18':
			title = 'Air + NET Ouest';
			break;
		case '$:partition:partition:19':
			title = 'SDNA';
			break;
		case '$:partition:partition:20':
			title = 'IGIENAIR MONACO';
			break;
		case '$:partition:partition:21':
			title = 'HYES';
			break;
		default:
		// require('./AntdCustomTheme.less');
	}

	return (
		<PublicLayout title={title}>
			<Page title="Connexion">
				<Card>
					<LoginForm />
				</Card>

				<Link
					style={{ marginTop: 30, textAlign: 'center' }}
					to="/forgotten-password"
				>
					Mot de passe oublié ?
				</Link>
			</Page>
		</PublicLayout>
	);
};

export default LoginPage;
